import { colorsPalettes } from "@similarweb/styles";
import styled from "styled-components";

export const StyledSignalFiltersWrapper = styled.div`
    margin-top: 6px;
    padding: 16px 16px 8px;

    border-radius: 8px;
    background-color: ${colorsPalettes.blue[50]};

    & > * {
        margin-bottom: 8px;
    }
`;
